module.exports = __webpack_public_path__ + "static/media/kayan-ceo.d18039cd.jpg";